/* 模板合同发起设置变量页面 */
<template>
  <div class="info-all" v-loading="loading">
    <!--左侧-->
    <el-aside width="2.80rem" class="aside-left" :style="{ height: boxHeight }">
      <p class="page-total">
        <span class="tit">文件签署列表</span>
        <span>共{{ fileList.length }}个</span>
      </p>
      <div class="page-con">
        <template v-for="(file, i) in fileList">
          <div
            :key="i"
            @click="chooseTemp(file, i)"
            :class="checkAct === i ? 'active' : ''"
            class="list"
          >
            <el-tooltip effect="light" placement="right-start">
              <div slot="content">此模板已设置变量</div>
              <!-- <i v-show="filePage(file)" class="icon icon-status_sign"></i> -->
              <span class="varable" :class="file.finished ? 'finish' : 'never'"
                >变量<i class="el-icon-check check-icon"></i
              ></span>
            </el-tooltip>
            <div class="bx">
              <img :src="fileIcon(file.fileName)" />
            </div>
            <p class="title" :title="file.tplName">
              {{ file.tplName || file.fileName }}
            </p>
          </div>
        </template>
      </div>
    </el-aside>
    <transition name="el-fade-in">
      <div
        class="aside"
        :style="{ height: boxHeight }"
        v-show="drawerShow"
      ></div>
    </transition>
    <!-- 中间展示 合同显示详情-->
    <template>
      <el-main class="main-content" :style="{ height: boxHeight }">
        <file-tpl
          v-show="checkTpl && checkTpl.tplVersion === 2"
          ref="file_tpl"
          :fileTplItem.sync="checkTpl"
          @turnFirst="turnFirst"
          @varListADD="varListADD"
        ></file-tpl>
        <web-tpl
          v-show="checkTpl && checkTpl.tplVersion !== 2"
          ref="web_tpl"
          :key="checkTpl.tplIdSec"
          :fileTplItem.sync="checkTpl"
          @varListADD="varListADD"
          @turnFirst="turnFirst"
        ></web-tpl>
      </el-main>
    </template>
  </div>
</template>

<script>
// components
import fileTpl from "./tplType/fileTpl.vue";
import webTpl from "./tplType/webTpl.vue";
// API
import { ApiMethods } from "@/assets/js/http-serve/http-methods";

export default {
  components: { fileTpl, webTpl },
  props: {
    fileList: {
      type: Array,
      default: []
    },
    setTempVariable: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    // 返回文件选择页面
    turnFirst() {
      this.$emit("update:setTempVariable", false);
    },
    // 切换模板
    async chooseTemp(file, i) {
      if (!file.isTpl)
        return this.$message.warning("上传的文件无需填写变量，不能切换");
      if (this.checkAct === i) return;
      let list = {},
        valid = false,
        checkVal = {},
        FILE_TPL = this.$refs.file_tpl,
        WEB_TPL = this.$refs.web_tpl;
      if (this.checkTpl.tplVersion === 2) {
        checkVal = await FILE_TPL.checkForm();
        const { chapteList: chapte } = FILE_TPL.getWidgets;
        // 获取填写的变量信息
        const varList =
          chapte &&
          chapte.map(item => {
            return {
              inputId: item.inputId,
              value: item.value
            };
          });
        list = { varList, finished: checkVal.valid };
      } else {
        checkVal = await WEB_TPL.checkForm();
        const { varList } = WEB_TPL.tpl;
        list = { varList: varList, finished: checkVal.valid };
      }
      this.varListADD({ list, index: this.checkAct });
      this.contractList = {};
      // 获取模板详情 tplVersion 1 web模板 2 文件模板
      this.checkAct = i;
      this.checkTpl = file;
    },
    filePage() {
      return function(file) {
        if (this.chapteJson.length > 0) {
          let arr = this.chapteJson.filter(
            v => v.targetId === file.fileOperVO.targetId
          );
          return arr.length > 0 ? true : false;
        }
      };
    },
    fileIcon(fileName) {
      let filesuffix = "tpl";
      if (fileName) {
        let first = fileName.lastIndexOf("."); //取到文件名开始到最后一个点的长度
        let namelength = fileName.length; //取到文件名长度
        filesuffix = fileName.substring(first + 1, namelength); //截取获得后缀名
      }
      switch (filesuffix) {
        case "pdf":
          return this.PDFImg;
        case "jpg":
          return this.JPGImg;
        case "doc":
        case "docx":
          return this.DOCImg;
        case "xls":
        case "xlsx":
          return this.XLSImg;
        case "tpl":
          return this.TPLImg;
        default:
          // wps
          return this.WPSImg;
      }
    },
    varListADD(params) {
      const { list, index, last } = params;
      const { varList, finished } = list,
        i = index ? index : this.checkAct;
      this.fileList[i].varList = varList;
      this.fileList[i].finished = finished || false;
      if (last) {
        let convertList = [];
        let tpls = this.fileList.filter(item => item.isTpl),
          finish = tpls.every(item => item.finished);
        if (!finish) return this.$message.warning("您还有未填写变量的模板");
        // 调用 多文件转pdf接口，用获取到的结果替换掉选择的模板
        this.loading = true;
        tpls.forEach(elem => {
          let { varList, tplVersion, tplIdSec } = elem;
          convertList.push({
            varList: JSON.stringify(varList),
            tplVersion,
            tplIdSec
          });
        });
        this.templateAPI
          .templateConvert(convertList)
          .then(res => {
            if (!res.success) return this.$message.error(res.description);
            const { data } = res;
            let newfiles = [];
            newfiles = data.map(file => {
              return {
                fileName: file.fileName,
                fileType: 1,
                fieSize: file.fieSize,
                fileOperVO: file,
                isTpl: true
              };
            });
            this.$emit("replaceFiles", newfiles);
          })
          .finally(() => {
            this.loading = false;
          });
      }
    }
  },
  data() {
    return {
      boxHeight: "1170px",
      checkAct: 0, // 当前显示合同选中文件 下标
      checkTpl: {}, // 当前选中的模板
      drawerShow: false, //侧边展示
      PDFImg: require("../../../static/images/advancedVersion/pdf.png"),
      JPGImg: require("../../../static/images/advancedVersion/JPG.png"),
      XLSImg: require("../../../static/images/advancedVersion/xlsx.png"),
      DOCImg: require("../../../static/images/advancedVersion/word.png"),
      WPSImg: require("../../../static/images/advancedVersion/WPS.png"),
      TPLImg: require("../../../static/images/advancedVersion/tpl.png"),
      templateAPI: ApiMethods.templateAPI,
      loading: false
    };
  }, // data end
  created() {
    this.checkTpl = this.fileList[this.checkAct];
  }
};
</script>

<style scoped lang="less">
.varable {
  position: absolute;
  top: 0;
  left: 0;
  display: inline-block;
  font-size: 12px;
  padding: 2px;
  border-radius: 3px;
  color: #fff;
}
.finish {
  background-color: #ec1c1c;
}
.never {
  display: none;
  background-color: #ccc;
}
.check-icon {
  margin-left: 2px;
  font-size: 15px;
  color: #fff;
}
.info-all {
  min-height: 100%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  -ms-flex-preferred-size: auto;
  flex-basis: auto;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  min-width: 0;
  position: fixed;
  top: 60px;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1000;
  background-color: #f5f5f5;
}
@mg: 0.2rem; // 左右side给中间合同流的间距
.aside-left {
  box-sizing: border-box;
  background-color: #ffffff;
  margin-right: @mg;
  overflow-y: auto;
  position: relative;
  z-index: 103;
  box-shadow: 0.02rem 0.03rem 0.16rem rgba(0, 0, 0, 0.12);

  .cred {
    color: #ec1c1c;
  }

  .list {
    position: relative;
    cursor: pointer;
    width: 168px;
    height: 155px;
    margin: 0.2rem auto;
    border-radius: 4px;
    overflow: hidden;
    border: 0.02rem solid #e5e5e5;
    box-shadow: 0px 1px 6px rgba(0, 0, 0, 0.16);
    i.icon {
      position: absolute;
      top: 0;
      right: 0;
      width: 0.4rem;
      height: 0.4rem;
      background-size: cover;
      cursor: pointer;
      z-index: 1;
    }
    .bx {
      width: 100%;
      height: 100px;
      text-align: center;
      line-height: 110px;
      position: relative;

      img {
        height: 48px;
        width: auto;
      }
    }

    p.title {
      overflow: hidden;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      text-overflow: ellipsis;
      padding: 0 10px;
      text-align: center;
      height: 45px;
      width: 100%;
      font-size: 14px;
      font-family: Source Han Sans SC;
      font-weight: 400;
      color: #290202;
      line-height: 23px;
    }
  }

  .list.active {
    border-color: #ec1c1c;
  }

  .page-total {
    color: #646464;
    font-size: 85%;
    border-bottom: 1px solid #f2f2f2;
    width: 100%;
    display: flex;
    justify-content: space-around;
    align-items: center;
    height: 60px;
    box-sizing: border-box;

    .tit {
      font-size: 16px;
      font-weight: bold;
      color: rgba(0, 0, 0, 0.85);
    }
  }

  .page-con {
    height: 85vh;
    position: absolute;
    width: 100%;
    left: 0;
    bottom: 0.1rem;
    top: 60px;
    overflow-y: auto;
  }
}
.aside {
  position: absolute;
  top: 0px;
  width: calc(100% - 2.8rem);
  z-index: 100;
  left: 2.8rem;
  background-color: rgba(0, 0, 0, 0.6);
}
.active {
  img {
    border-color: #ec1c1c;
  }

  span {
    background-color: #ec1c1c;
  }
}
</style>



// WEBPACK FOOTER //
// pages/initiation/components/tplSetting.vue